import React, { useEffect, useState } from 'react';
import './RedirectionPage.scss';
import { Helmet } from 'react-helmet-async';
import CustomBtn from '../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';
import Loading from '../../components/Loading/Loading';
import { useCollectionQuery } from '../../services/strapi/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { isExternalLink, safeHtml } from '../../services/helpers';
import StrapiImageWithSkeleton from '../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import { useLocation } from 'react-router-dom';
import Error404Page from '../Error404Page/Error404Page';

export default function RedirectionPage() {
    const isMobile = useMediaQuery({ maxWidth: 896 }); // Breakpoint pour MD

    const location = useLocation();
    const slug = location.pathname.slice(1);   
    const [isProcessing, setIsProcessing] = useState(false);

    const strapiPage = 'redirections';

    const queryClient = useQueryClient();

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useCollectionQuery(
        strapiPage,
        slug,
        false
    );

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-collection', strapiPage, slug]);

    // État transitoire pour éviter le clignotement
    useEffect(() => {
        if (isLoading) {
            setIsProcessing(true);
        } else {
            // Délai court pour assurer une transition fluide
            const timer = setTimeout(() => setIsProcessing(false), 200);
            return () => clearTimeout(timer);
        }
    }, [isLoading]);

    // N'afficher le chargement que si les données ne sont pas disponibles et qu'on est en cours de chargement
    const showLoading = (isLoading || isProcessing) && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    if (showLoading) return <Loading />;
    if (!displayData || (Array.isArray(displayData) && displayData.length === 0) || error) return <Error404Page />;


    return (
        <div className="redirection-page">
            <Helmet>
                <title>{displayData[0]?.SEO?.TitreOnglet}</title>
            </Helmet>
            <div className="redirection-page__content">
                <StrapiImageWithSkeleton
                    picture={displayData[0]?.Photo}
                    size='large'
                    loading="eager"
                    fetchpriority='high'
                    className='redirection-page__picture'
                />
                <div className='redirection-page__text_container'>
                    <div className="redirection-page__text" dangerouslySetInnerHTML={safeHtml(displayData[0]?.Texte)} />
                    <CustomBtn
                        type={isExternalLink(displayData[0]?.Bouton?.LienBouton) ? 'external' : 'internal'}
                        title={displayData[0]?.Bouton?.TexteBouton}
                        link={
                            displayData[0]?.Bouton?.LienBouton === null ?
                                '/'
                                :
                                (isExternalLink(displayData[0]?.Bouton?.LienBouton) ?
                                displayData[0].Bouton.LienBouton
                                    :
                                    '/' + displayData[0]?.Bouton?.LienBouton)
                        }
                        bkg_color={'#361215'}
                        bkg_color_hover={'#EEE6DB'}
                        text_color={'#EEE6DB'}
                        text_color_hover={'#361215'}
                        border_color={'#361215'}
                        border_color_hover={'#361215'}
                        font_family={"Great Vibes"}
                        font_size={'30px'}
                        font_weight={'normal'}
                        border_radius={'3px'}
                        width={'330px'}
                        height={'60px'}
                        margin={'10px 0 0 0'}
                    />
                </div>
            </div>

        </div>
    )
}
